import { ActionProps } from '../ui/molecules/Block/types';

export const dataBtnsFormats = (lang: string): ActionProps[] => [
  {
    id: 1,
    text: `Slider`,
    img: `/assets/img/main/slider-${lang}.jpg`,
  },
  {
    id: 2,
    text: `Native`,
    img: `/assets/img/main/native-slide-mobile-${lang}.jpg`,
  },
  {
    id: 3,
    text: `Floor-Ad`,
    img: `/assets/img/main/floor-ad-slide-${lang}.jpg`,
  },
  {
    id: 4,
    text: `AMP/Turbo`,
    img: `/assets/img/main/turbo-mobile-${lang}.jpg`,
  },
];

export const dataBtnsFormatsDesktop = (lang: string): ActionProps[] => [
  {
    id: 1,
    text: `Slider`,
    img: `/assets/img/main/slider-desktop-${lang}.png`,
  },
  {
    id: 2,
    text: `Native`,
    img: `/assets/img/main/native-desktop-${lang}.png`,
  },
];

export const dataBtnsPublishersFormats = (lang: string): ActionProps[] => [
  {
    id: 1,
    text: `Slider`,
    img: `/assets/img/main/slider-${lang}.jpg`,
  },
  {
    id: 2,
    text: `Native`,
    img: `/assets/img/main/turbo-mobile-${lang}.jpg`,
  },
  {
    id: 3,
    text: `InRead`,
    img: `/assets/img/main/in-read-mobile-${lang}.jpg`,
  },
  {
    id: 4,
    text: `Floor-Ad`,
    img: `/assets/img/main/floor-ad-slide-${lang}.jpg`,
  },
];

export const dataBtnsPublishersFormatsDesktop = (
  lang: string,
): ActionProps[] => [
  {
    id: 1,
    text: `Slider`,
    img: `/assets/img/main/slider-desktop-${lang}.png`,
  },
  {
    id: 2,
    text: `Native`,
    img: `/assets/img/main/native-desktop-${lang}.png`,
  },
  {
    id: 3,
    text: `InRead`,
    img: `/assets/img/main/inread-desktop-${lang}.png`,
  },
];
